import React, {useState} from "react";

const PREVIEW = 8;

function EquipmentSection({title, items}) {
    if (items.length === 0) return null;

    const half = Math.ceil(items.length / 2);
    const firstCol = items.slice(0, half);
    const secondCol = items.slice(half);

    return (
        <div className="vehicle-tabs__equip-section">
            <p className="vehicle-tabs__equip-section-title">{title}</p>
            <div className="vehicle-tabs__equip-table">
                <div className="vehicle-tabs__equip-col">
                    {firstCol.map((item, i) => (
                        <div key={i} className="vehicle-tabs__equip-item">{item}</div>
                    ))}
                </div>
                <div className="vehicle-tabs__equip-col">
                    {secondCol.map((item, i) => (
                        <div key={i} className="vehicle-tabs__equip-item">{item}</div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function VehicleEquipment({offer}) {

    const [expanded, setExpanded] = useState(false);

    const standard = offer.standardEquipment;
    const additional = offer.additionalEquipment;
    const total = standard.length + additional.length;

    if (total === 0) return null;

    let visibleStandard = standard;
    let visibleAdditional = additional;

    if (!expanded && total > PREVIEW) {
        visibleStandard = standard.slice(0, PREVIEW);
        visibleAdditional = additional.slice(0, PREVIEW - visibleStandard.length);
    }

    return (
        <>
            <EquipmentSection title="Wyposażenie podstawowe" items={visibleStandard}/>
            <EquipmentSection title="Wyposażenie dodatkowe" items={visibleAdditional}/>

            {total > PREVIEW && (
                <button
                    type="button"
                    className="vehicle-tabs__show-more"
                    onClick={() => setExpanded(e => !e)}
                >
                    {expanded ? 'Pokaż mniej' : 'Pokaż więcej'}
                    <span className={'vehicle-tabs__show-more-arrow' + (expanded ? ' up' : '')}>›</span>
                </button>
            )}

            {offer.availability !== 'IN_STOCK' && (
                <p className="vehicle-tabs__equip-note">
                    <em>Prezentowana oferta zawiera wyposażenie podstawowe samochodu.
                        Termin dostawy auta oraz ostateczna cena zostanie określona po uwzględnieniu
                        wybranego wyposażenia dodatkowego oraz rabatu GO-leasing.
                        Zapraszamy do kontaktu z naszym doradcą.</em>
                </p>
            )}
        </>
    );
}

export default VehicleEquipment;
